module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductDetailImages":{"showMorePictures":"Načíst další fotky ({count})"}},"de":{"ProductDetailImages":{"showMorePictures":"Weitere Fotos laden ({count})"}},"sk":{"ProductDetailImages":{"showMorePictures":"Načítať ďalšie fotky ({count})"}}}')
  delete Component.options._Ctor
}
